import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Container, Button, Popup } from 'semantic-ui-react'
import history from 'utils/history'
import { parseQueryString, buildQueryString, getSourceUrl } from 'utils/functions'
import { MAX_AJAX_RETRY, RETRY_DELAY } from 'utils/constants'
import css from './Player.module.sass'

class Player extends Component {
  constructor () {
    super(...arguments)

    this.state = {
      currentDts: 0,
      retry: 1,
      sourceUrl: ''
    }

    this.onPlayerLoadedData = this.onPlayerLoadedData.bind(this)
    this.onPlayerTimeUpdate = this.onPlayerTimeUpdate.bind(this)
    this.onPlayerError = this.onPlayerError.bind(this)
  }

  async componentWillMount () {
    const sourceUrl = await this._prepareSourceUrl()
    this.setState({ sourceUrl })
  }

  componentDidUpdate () {
    if (this.state.sourceUrl) {
      this._detachPlayerEvents()
      this._attachPlayerEvents()
    }
  }

  componentWillUnmount () {
    this._detachPlayerEvents()
  }

  _detachPlayerEvents () {
    this.playerElement.removeEventListener('loadeddata', this.onPlayerLoadedData)
    this.playerElement.removeEventListener('timeupdate', this.onPlayerTimeUpdate)
    this.playerElement.removeEventListener('error', this.onPlayerError)
  }

  _attachPlayerEvents () {
    this.playerElement.addEventListener('loadeddata', this.onPlayerLoadedData)
    this.playerElement.addEventListener('timeupdate', this.onPlayerTimeUpdate)
    this.playerElement.addEventListener('error', this.onPlayerError)
  }

  onPlayerLoadedData () {
    const { onLoaded } = this.props

    onLoaded(this.playerElement)
  }

  async onPlayerTimeUpdate () {
    const sourceUrl = await this._prepareSourceUrl()
    const currentDts = parseInt(this.playerElement.currentTime * 1000)

    this.setState({
      currentDts,
      sourceUrl
    })
  }

  onPlayerError (e) {
    const { mode } = parseQueryString()
    const { retry } = this.state
    let replaceUrl = `?${buildQueryString()}`

    if (mode) replaceUrl += `&mode=${mode}`

    if (
      e.target.error &&
      e.target.error.code === this.playerElement.error.MEDIA_ERR_SRC_NOT_SUPPORTED
    ) {
      if (retry < MAX_AJAX_RETRY) {
        setTimeout(() => {
          this.setState((prevState) => ({ retry: prevState.retry + 1 }))
        }, RETRY_DELAY)
      } else {
        sessionStorage.setItem('mediaEditor_notification', 'failedGetMedia')
        history.replace(replaceUrl)
      }
    }
  }

  handleCopyPasteDTS = (e) => {
    this.props.setDts({ dts: this.state.currentDts })
  }

  async _prepareSourceUrl () {
    const { mediaParams: { mediaUrl } } = this.props
    const { retry } = this.state
    let sourceUrl = await getSourceUrl(mediaUrl)

    if (retry !== 1) sourceUrl += `&retry=${retry}`

    return sourceUrl
  }

  render () {
    const { sourceUrl } = this.state

    return (
      <Container>
        { sourceUrl &&
          <video
            ref={(player) => { this.playerElement = player }}
            className={css.video}
            src={sourceUrl}
            controls
          />
        }
        <div className={css.bottom}>
          Текущий dts - {this.state.currentDts}
          <Popup
            content='Скопировать dts'
            position='bottom left'
            inverted
            trigger={
              <Button
                onClick={this.handleCopyPasteDTS}
                size='mini'
                icon='copy'
                basic
                compact
                style={{
                  position: 'relative',
                  left: 10
                }}
              />
            }
          />
        </div>
      </Container>
    )
  }
}

const {
  func,
  object
} = PropTypes

Player.propTypes = {
  onLoaded: func.isRequired,
  mediaParams: object.isRequired,
  setDts: func.isRequired
}

export default Player



// WEBPACK FOOTER //
// ./src/components/Player/Player.js